// FE auth-guard helpers: JWT validity check + where to send logged-out users.

/** Decode a JWT payload (base64url JSON) without a library. Null if unparseable. */
function decodeJwtPayload(token: string): Record<string, any> | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * A token is valid only if it decodes AND is not past its `exp`.
 * A missing/malformed token is treated as INVALID so the guard bounces to login.
 * (The backend always signs with an `exp` claim via JWT_EXPIRES_IN.)
 */
export function isTokenValid(token: string | null | undefined): boolean {
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  if (typeof payload.exp !== 'number') return true; // no exp to validate against
  return Date.now() < payload.exp * 1000;
}

/**
 * Where to send logged-out / invalid-token users. In production the public
 * landing + login live in the standalone Astro marketing zone at the root
 * domain — set REACT_APP_MARKETING_URL to bounce there. Falls back to the
 * in-app /login route (used in local dev).
 */
export const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || '';
export const LOGIN_PATH = '/login';

/** Absolute/relative href for the logged-out destination. */
export function loggedOutHref(): string {
  return MARKETING_URL || LOGIN_PATH;
}
